import React from 'react';
import { Auth } from 'aws-amplify';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { Icon, Menu } from 'semantic-ui-react';
import { useAgeReadyContext } from '../../AgeReadyContext/AgeReadyContext';

const MobileSliderMenu: React.FunctionComponent = () => {
  const location = useLocation();
  const history = useHistory();

  const { caregiverStore } = useAgeReadyContext();

  const logout = async () => {
    await Auth.signOut();
    caregiverStore.logout();
    history.push('/');
  };

  return (
    <>
      {!!caregiverStore.partnerCode && !!caregiverStore.isAdmin && !location.pathname.includes('admin') && (
        <Menu.Item
          as={Link}
          active={location.pathname === `admin/${caregiverStore.partnerCode}`}
          to={`admin/${caregiverStore.partnerCode}`}
        >
          Admin
        </Menu.Item>
      )}
      <Menu.Item
        as={Link}
        active={location.pathname === '/home'}
        to='/home'
      >
        <Icon name='server' />
        Home
      </Menu.Item>
      <Menu.Item
        as={Link}
        active={location.pathname === '/user-profile'}
        to='/user-profile'
      >
        <Icon name='user outline' />
        User Profile
      </Menu.Item>
      <Menu.Item onClick={logout} to='/'>
        <Icon name='sign-out' />
        Sign Out
      </Menu.Item>
    </>
  );
};

export default MobileSliderMenu;
